import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "raw-cell" }
const _hoisted_2 = { class: "raw-cell-header" }
const _hoisted_3 = { key: 0 }

import { ref, shallowRef, computed, getCurrentInstance, inject, onBeforeMount, onBeforeUnmount } from "vue";
import CodeEditor from "../misc/CodeEditor.vue";
import { findSelectableParent } from "../../util";
import { type BeakerSessionComponentType } from '../session/BeakerSession.vue';


import { BeakerRawCell } from "beaker-kernel/src";
const __default__ = {
    modelClass: BeakerRawCell,
    icon: "pi pi-question-circle",
};


export default /*@__PURE__*/_defineComponent({
  ...__default__,
  __name: 'BeakerRawCell',
  props: [
    "cell",
],
  setup(__props, { expose: __expose }) {

const props = __props;

const instance = getCurrentInstance();
const cell = ref(props.cell);
const codeEditorRef = ref<InstanceType<typeof CodeEditor>>(null);
const beakerSession = inject<BeakerSessionComponentType>("beakerSession");

enum ExecuteStatus {
  Success = 'success',
  Modified = 'modified',
  Error = 'error',
  Pending = 'pending',
}

const rawExtensions = computed(() => {
    const ext = [];
    // if (theme.value === 'dark') {
    //     ext.push(oneDark);
    // }
    return ext;

});


const execute = (evt: any) => {
    // Nothing to do but exit
    exit();
}

const enter = () => {
    codeEditorRef.value?.focus();
}

const exit = () => {
    // Be sure to blur editor even if we don't also refocus below.
    codeEditorRef.value.blur();
    let target: HTMLElement = (instance.vnode.el as HTMLElement);
    const selectableParent = findSelectableParent(target);
    selectableParent?.focus();
}

const clear = () => {
    cell.value.source = "";
}

__expose({
    execute,
    enter,
    exit,
    clear,
    model: cell,
});

onBeforeMount(() => {
    beakerSession.cellRegistry[cell.value.id] = instance.vnode;
});

onBeforeUnmount(() => {
    delete beakerSession.cellRegistry[cell.value.id];
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[1] || (_cache[1] = _createElementVNode("span", { class: "raw-cell-title" }, "Raw cell", -1)),
      (props.cell.cell_type !== 'raw')
        ? (_openBlock(), _createElementBlock("span", _hoisted_3, " - (Unrenderable cell type '" + _toDisplayString(props.cell.cell_type) + "')", 1))
        : _createCommentVNode("", true)
    ]),
    _createVNode(CodeEditor, {
      "display-mode": "dark",
      language: "julia",
      modelValue: cell.value.source,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((cell.value.source) = $event)),
      ref_key: "codeEditorRef",
      ref: codeEditorRef,
      placeholder: "Raw cell content...",
      autofocus: false
    }, null, 8, ["modelValue"])
  ]))
}
}

})